import React, {useMemo} from "react";
import {Box, Typography} from "@mui/material";
import {useKeyDataStore} from "../../../api/KeyDataStore";
import {DashboardWidget, DashboardWidgetItem} from "../DashboardWidget";
import {AppPages, usePageUrl} from "../../../app-layout/AppPages";
import {Link as RouterLink} from "react-router-dom";
import {KeyChip} from "../../../components/key-chip/KeyChip";
import {KeyLocationShield} from "../../../components/location/KeyLocationShield";
import {KeyHistoryButton} from "../../history-dialog/HistoryDialogContext";
import {KeyData_Read} from "../../../util/access/Permission";
import {lostAndDamagedCards} from "./LostAndDamagedCards";
import {CsvModel} from "../../../util/CSVWriteUtil";
import {KeySnapshot} from "../../../api/Model";
import {RemoteValue} from "../../../util/RemoteValue";

const lostAndDamagedCardsCsvModel = RemoteValue.fromValue(new CsvModel<KeySnapshot>([
    {header: 'Key', value: ({key}) => key.keyNumber},
    {header: 'Status', value: ({historyRecord}) => historyRecord.location.type},
    {header: 'Since', value: ({historyRecord}) => historyRecord.from ?? ''},
]));

export function LostAndDamagedCardsWidget() {
    const pageUrl = usePageUrl();
    const keys = useKeyDataStore(state => state.remoteValue);
    const problems = useMemo(() => keys.map(lostAndDamagedCards), [keys]);

    return (
        <DashboardWidget
            title="Lost and damaged keys"
            description="Keys currently marked as lost or damaged that have not yet been deactivated."
            problems={problems}
            requiredPermissions={KeyData_Read}
            link={pageUrl(AppPages.keys, {}, {location: ['lost', 'damaged']})}
            csvModel={lostAndDamagedCardsCsvModel}
            renderProblem={({key, historyRecord}, index) => (
                <DashboardWidgetItem
                    key={`${key.id}-${historyRecord.id}`}
                    index={index}
                    left={
                        <>
                            <Box sx={{minWidth: '96px'}}>
                                <RouterLink to={pageUrl(AppPages.keys, {}, {search: key.keyNumber})}>
                                    <KeyChip keyData={key} record={historyRecord}/>
                                </RouterLink>
                            </Box>
                            <KeyLocationShield location={historyRecord.location}/>
                        </>
                    }
                    right={
                        <>
                            {historyRecord.from && (
                                <Typography variant="body2" color="text.secondary">
                                    Since {historyRecord.from}
                                </Typography>
                            )}
                            <KeyHistoryButton keyData={key}/>
                        </>
                    }
                />
            )}
        />
    );
}
